<template>
  <div class="common-dialog__verification">
    <div class="dialog-content__hd">
      <span>{{ $attrs.header }}</span>

      <div class="header-close-icon cur-pointer">
        <svg-icon icon-class="close" @click="$emit('model-input', false)" />
      </div>
    </div>
    <div class="dialog-content__bd">
      <p v-if="$attrs.title" class="body-title">{{ $attrs.title }}</p>
      <p class="body-warning">
        <span
          >请务必认真对待每次的授权，因为您每次的授权将会在系统给予记录，如出现风险将由操作人与授权人承担</span
        >
        <span class="light-active">全部责任！</span>
      </p>
      <div class="dialog-content__bd-content">
        <template v-if="$attrs.operation">
          <p class="label">手机号（操作人）</p>
          <el-input v-model="data.phone" placeholder="请输入手机号码" />
          <p class="label">通证秘钥（操作人）</p>
          <el-input v-model="data.password" placeholder="请输入通证秘钥" />
        </template>
        <p class="label">手机号（授权人）</p>
        <el-input v-model="data.confirmPhone" placeholder="请输入手机号码" />
        <p class="label">通证秘钥（授权人）</p>
        <el-input v-model="data.confirmPassword" placeholder="请输入通证秘钥" />
      </div>
    </div>
    <div v-if="!$attrs.hiddenButton" class="dialog-content__ft">
      <button class="confirm" @click="$emit('confirm', data)">
        {{ $attrs.confirmText }}
      </button>
    </div>
  </div>
</template>

<script>
export default {
  inheritAttrs: false,
  data() {
    return {
      data: {
        phone: '',
        password: '',
        confirmPhone: '',
        confirmPassword: ''
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.common-dialog__verification {
  width: 450px;

  .dialog-content__hd {
    position: relative;
    height: 50px;
    background: #f1f3f6;
    line-height: 50px;
    text-align: center;
    font-size: 16px;
    color: #212832;

    .header-close-icon {
      position: absolute;
      right: 16px;
      top: 16px;
      width: 24px;
      height: 24px;
      line-height: 1;

      svg {
        width: 100%;
        height: 100%;
      }
    }
  }

  .dialog-content__bd {
    padding: 45px 30px;

    .body-title {
      margin-bottom: 16px;
      line-height: 25px;
      text-align: center;
      font-size: 18px;
      font-weight: bold;
      // color: var(--primary);
      color: #4068f7;
    }

    .body-warning {
      margin-bottom: 30px;
      font-size: 0;
      line-height: 20px;
      color: #c4c4c4;

      span {
        font-size: 14px;

        &.light-active {
          font-weight: bold;
          color: #ff5a48;
        }
      }
    }

    &-content {
      font-size: 14px;

      .title {
        margin-bottom: 25px;
        font-size: 16px;
        text-align: center;
      }

      .label {
        margin: 8px 0;
        height: 20px;
        line-height: 20px;
      }

      .total {
        font-size: 40px;
        font-weight: bold;
        // color: var(--primary);
        color: #4068f7;
      }

      /deep/ .el-input,
      /deep/ .colorfule-selects {
        width: 230px !important;

        &__inner {
          height: 36px;
          background-color: #f5f6f7;
          border: 1px solid #f5f6f7;
          border-radius: 6px;
          font-size: 14px;

          &::focus {
            border-color: #4068f7;
          }
        }
      }
    }
  }

  .dialog-content__ft {
    padding: 15px 0;
    text-align: center;
    border-top: 1px solid #f1f3f6;

    button {
      width: 140px;
      height: 40px;
      border: 0;
      font-size: 15px;
      border-radius: 5px;
      font-weight: bold;
      user-select: none;
      cursor: pointer;
      color: #fff;

      &.confirm {
        background: var(--primary);

        &:active {
          background: #395dde;
        }
      }
    }
  }
}
</style>